import { Navigate } from 'react-router-dom'
import React, {useEffect, useState} from "react";
import LocalStorageService from "../Services/Storage/LocalStorageService";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";

export enum Role {
    Normal = 'Normal' as any,
    Supplier = 'Supplier' as any,
    Admin = 'Admin' as any
}

interface Props {
    component: React.ComponentType
    path?: string
    roles?: Array<any>
}

export const PrivateRoute: React.FC<Props> = ({ component: RouteComponent, roles }) => {
    //const isAuthenticated = useIsAuthenticated();
    //const {instance} = useMsal();
    const isAuthenticated = LocalStorageService.getAccessToken() !== null;

    const [userRoles, setUserRoles] = useState<string[]>([]);

    useEffect(() => {
        if (isAuthenticated) {
            const role = LocalStorageService.getAccessRole();
            //insert role to userroles
            setUserRoles([role!]);
        }
    }, [isAuthenticated]);
    
    let userHasRequiredRole = userRoles[0] && roles && Object.keys(Role)[Object.values(roles).indexOf(userRoles[0])];
    
    if (isAuthenticated && (roles === undefined || userHasRequiredRole)) {
        return <RouteComponent />
    }

    if (isAuthenticated && (roles !== undefined && !userHasRequiredRole)) {
        return <p>Access denied.</p>
    }

    return <Navigate to="/auth/login" />
}